import React, { PropsWithChildren, useRef, useState } from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { FadeContainer } from './fade-container';
import { FadeButton } from './fade-button';

export const VLIMIT_HEIGHT = 346;

export interface SectionVlimitProps {
  onCollapsedToggle: (cancelAnimations?: boolean) => void;
  onSendAnalytics?: (isFade: boolean) => void;
}

export const SectionVlimit: React.FC<SectionVlimitProps & PropsWithChildren> = ({
  onCollapsedToggle,
  onSendAnalytics,
  children,
}) => {
  const vSectionRef = useRef<HTMLDivElement | null>(null);
  const [isLimited, setIsLimited] = useState(false);
  const [isFade, setFade] = useState(true);
  const handleClick = () => {
    setFade(!isFade);
    if (onSendAnalytics) onSendAnalytics(!isFade);
  };
  React.useEffect(() => {
    onCollapsedToggle(true);
  }, [isFade, onCollapsedToggle]);
  React.useEffect(() => {
    if (
      vSectionRef?.current?.children[0]?.clientHeight &&
      vSectionRef.current?.children[0].clientHeight > VLIMIT_HEIGHT
    ) {
      setIsLimited(true);
    }
  }, [vSectionRef]);
  const carouselHeight = { height: `${isLimited && isFade ? `${VLIMIT_HEIGHT}px` : 'auto'}` };
  return (
    <SectionVlimitWrapper data-qa="section-content-vlimited">
      <div ref={vSectionRef} className={vSection} style={carouselHeight}>
        {children}
      </div>
      {isLimited && isFade && <FadeContainer />}
      {isLimited && <FadeButton open={isFade} onClick={handleClick} />}
    </SectionVlimitWrapper>
  );
};
export const SectionVlimitWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 880px;
  margin: 0;
`;

export const vSection = css`
  overflow-y: hidden;
`;
